var React = require('react');

function ClockInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"clock"},[React.createElement("path",{"id":"Vector","d":"M7.00008 12.8334C10.2217 12.8334 12.8334 10.2217 12.8334 7.00008C12.8334 3.77842 10.2217 1.16675 7.00008 1.16675C3.77842 1.16675 1.16675 3.77842 1.16675 7.00008C1.16675 10.2217 3.77842 12.8334 7.00008 12.8334Z","stroke":"#990000","strokeWidth":"1.16667","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M7 3.5V7L9.33333 8.16667","stroke":"#990000","strokeWidth":"1.16667","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

ClockInline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = ClockInline;

ClockInline.default = ClockInline;
